<template>
  <div class="top">
    <webHead
      ref="webHead"
      :parentNavIndex="0"
      @toNewProduct="toNewProduct"
    ></webHead>

    <div>
      <el-carousel height="39vw">
        <el-carousel-item v-for="item in homeSwiper" :key="item.id">
          <img
            :src="item.displayContent"
            @click="toProductDetail(item.seriesId)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="productType">
      <h1 class="title">{{ $t('home.product_type') }}</h1>
      <div class="product">
        <el-row :gutter="30">
          <el-col
            :xs="24"
            :md="12"
            :lg="6"
            v-for="(item, index) in productType"
            :key="item.id"
          >
            <div @click="toProductCategory(item.categoryId, index)">
              <img :src="item.displayContent" />
              <h4 class="cate">{{ item.title }}</h4>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="previewMoreProduct">
        <button @click="previewMoreProduct">
          {{ $t('home.View_more_products') }}
        </button>
      </div>
    </div>

    <div class="newProduct">
      <h1 class="title">{{ $t('home.New_product_on_sale') }}</h1>
      <swiper
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="item in newProduct" :key="item.id">
          <img
            :src="item.displayContent"
            @click="newToProductDetail(item.seriesId)"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="mask"></div>
    </div>
    <div class="companyIntroduction">
      <img :src="aboutUs" alt="" @click="toAboutUs" />
    </div>
    <div class="news">
      <h1 class="title">{{ $t('home.News_and_Information') }}</h1>
      <div class="newList">
        <el-row :gutter="30">
          <el-col
            :xs="24"
            :md="8"
            v-for="(item, index) in newsList"
            :key="index"
          >
            <div class="newsBox" @click="toNewsDetail(item.id)">
              <img
                :src="'http://47.93.25.52:9000/publicpic/' + item.coverPicture"
                alt=""
              />
              <h3 class="newTitle">
                {{ item.title }}
              </h3>
              <div class="date">
                {{ moment(item.newsDate).format('YYYY-MM-DD') }}
              </div>
              <div class="link">
                <a @click="toNewsDetail(item.id)">#{{ item.label }}</a>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="previewMoreNews">
          <button @click="previewMoreNewsBtn" v-if="previewMoreNews > 3">
            {{ $t('home.View_more_information') }}
          </button>
        </div>
      </div>
    </div>

    <webFooter ref="webFooter"></webFooter>
  </div>
</template>

<script>
import webHead from '@/pages/webHead/webHead.vue';
import webFooter from '@/pages/webFooter/webFooter.vue';
import { GetContentSetting } from '@/http/home';
import { newsConsultationFind } from '@/http/newsInfo';
import moment from 'moment';

export default {
  data() {
    return {
      swiperOption: {
        initialSlide: 5,
        slidesPerView: 'auto',
        paginationClickable: true,
        spaceBetween: 30,
        // 设置自动轮播
        autoplay: {
          stopOnLastSlide: false,
          disableOnInteraction: false,
          delay: 3000,
        },
        loopFillGroupWithBlank: true,
        normalizeSlideIndex: true,
        autoplayDisableOnInteraction: false,
        speed: 3000, // 匀速播放频率
        freeMode: true,
        // 设置轮播可循环
        loop: true,
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true,
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      identifierList: [
        'e5a8b90bd6ba11386689cb132b492afb',
        '45398254651940f5bfbeed4784fe70fb',
        'a98ed3caf53f5e3b5beda26c898661f0',
        '198a584053a04b94b1a7ad1564bccbb6',
      ],
      homeSwiper: [],
      productType: [],
      newProduct: [],
      newsList: [],
      previewMoreNews: 0,
      aboutUs: [],
    };
  },
  methods: {
    moment,
    onSwiper(swiper) {
      console.log(swiper);
      console.log('11');
    },
    onSlideChange() {
      // console.log('slide change');
    },
    async GetContentSetting() {
      const res = await GetContentSetting(this.identifierList);
      this.homeSwiper = res.data.settingMap['e5a8b90bd6ba11386689cb132b492afb'];
      this.productType =
        res.data.settingMap['45398254651940f5bfbeed4784fe70fb'];
      this.newProduct = res.data.settingMap['a98ed3caf53f5e3b5beda26c898661f0'];
      this.aboutUs =
        res.data.settingMap[
          '198a584053a04b94b1a7ad1564bccbb6'
        ][0].displayContent;
      console.log(this.aboutUs);
    },
    async newsConsultationFind(type) {
      const res = await newsConsultationFind({ pageIndex: 1 }, type);
      console.log(res);
      this.newsList = res.data.newsConsultations;
      if (this.newsList.length > 3) {
        this.newsList = this.newsList.slice(0, 3);
      }
      this.previewMoreNews = res.data.newsConsultations.length;
    },
    previewMoreNewsBtn() {
      this.$router.push('/newsInfo');
    },
    previewMoreProduct() {
      this.$router.push('/product/main');
    },
    toProductCategory(categoryId, index) {
      this.$router.push({
        path: '/product/main',
        query: { type: index, categoryId: categoryId },
      });
    },
    toAboutUs() {
      this.$router.push('/aboutUs');
    },
    toNewProduct() {
      this.$router.push('/home');
      document.querySelector('.newProduct').scrollIntoView();
    },
    toNewsDetail(id) {
      window.open(
        this.$router.resolve({
          path: '/newsDetail',
          query: { detailId: id },
        }).href,
        '_blank'
      );
      // this.$router.push({ path: '/newsInfo', query: { detailId: id } });
    },
    toProductDetail(seriesId) {
      console.log('toProductDetail');
      window.open(
        this.$router.resolve({
          path: '/product/detail',
          query: { seriesId: seriesId },
        }).href,
        '_blank'
      );
    },
    newToProductDetail(seriesId) {
      console.log('toProductDetail');
      window.open(
        this.$router.resolve({
          path: '/product/detail',
          query: { seriesId: seriesId, newProduct: true },
        }).href,
        '_blank'
      );
    },
  },
  components: {
    webHead,
    webFooter,
    // Swiper, SwiperSlide
  },
  mounted() {
    this.GetContentSetting();
    this.newsConsultationFind('');
    document.querySelector('.top').scrollIntoView();
  },
};
</script>

<style scoped lang="less">
@import '@/theme.less';
.el-carousel__item img {
  height: 100%;
  width: 100%;
}
/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  opacity: 0.5;
}
/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: @themeColor;
  border-radius: 50%;
  opacity: 1;
}
.learnMore {
  position: absolute;
  background-color: aqua;
  button {
    width: 30px;
    height: 30px;
  }
}
.productType {
  background-color: #f0f0f0;
  padding-top: 80px;
  .title {
    text-align: center;
    margin-bottom: 55px;
  }
  .product {
    padding: 0px 8vw;
    .el-col {
      img {
        width: 100%;
        border-radius: 10px;
      }
      .cate {
        text-align: center;
        padding: 25px 0px;
      }
    }
    .el-col:hover {
      color: @themeColor;
    }
  }
  .previewMoreProduct {
    text-align: center;
    padding-bottom: 75px;
    button {
      border: 2px solid @themeColor;
      padding: 20px 50px;
      color: @themeColor;
      font-size: 16px;
      border-radius: 35px;
    }
  }
}

/deep/.newProduct {
  width: 80vw;
  padding-top: 60px;
  margin: auto;
  position: relative;
  margin-bottom: 30px;
  .title {
    margin-bottom: 55px;
  }
  .swiper-container {
    width: 100%;
    --swiper-navigation-color: @themeColor; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 20px; /* 设置按钮大小 */
  }
  .swiper-slide {
    width: 70%;
    img {
      display: block;
      width: 100%;
      cursor: pointer;
    }
  }
  .swiper-pagination-bullet-active {
    background-color: @themeColor;
  }
  // .swiper-slide:nth-child(2n) {
  //   width: 60%;
  // }
  // .swiper-slide:nth-child(3n) {
  //   width: 40%;
  // }
  .mask {
    position: absolute;
    background-color: #fff;
    bottom: 0px;
    right: 0px;
    width: 30%;
    height: 16vw;
    z-index: 10000;
  }
}
.companyIntroduction {
  height: 55vw;
  img {
    width: 100%;
    height: 100%;
  }
}
.news {
  padding-top: 80px;
  .title {
    text-align: center;
    margin-bottom: 55px;
  }
  .newList {
    padding: 0px 8vw;
    .el-col {
      .newsBox {
        box-shadow: 0px 0px 10px 0px #8a8a8a;
        img {
          width: 100%;
          display: block;
        }
        .newTitle {
          height: 120px;
          padding: 30px;
        }
        .date {
          padding: 0px 30px 5px 30px;
          color: #8a8a8a;
        }
        .link {
          padding: 0px 30px 30px 30px;
          color: @themeColor;
        }
      }
    }
    .previewMoreNews {
      text-align: center;
      padding-bottom: 75px;
      padding-top: 50px;
      button {
        border: 2px solid @themeColor;
        padding: 20px 50px;
        color: @themeColor;
        font-size: 16px;
        border-radius: 35px;
        background-color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
